import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// define translations for your app
const resources = {
    en: {
        translation: {
            calendar_settings: "Calendar settings",
            edit_profile: "Edit profile",
            change_consultation: "Change consultation",
            add_consultation: "Add consultation",
            weekly_view: "Weekly view",
            daily_view: "Daily view",
            unsaved_data_loss: "All unsaved data will be lost!",
            Monday: "Monday",
            Tuesday: "Tuesday",
            Wednesday: "Wednesday",
            Thursday: "Thursday",
            Friday: "Friday",
            Saturday: "Saturday",
            Sunday: "Sunday",
            odd_week: "Odd week",
            even_week: "Even week",
            consultation_time: "Consultation time",
            sure_close: "Are you sure you want to close",
            back: "Back",
            close: "Close",
            all_examinations: "All examinations",
            no_room_selected: "No room selected",
            use_odd_week: "Use odd week",
            save: "Save",
            week: "week",
            patient: "Patient",
            birth_date: "Birth date",
            qualification: "Qualification",
            specialization: "Specialization",
            choose: "Choose...",
            from_patient: "From the patient",
            from_institution: "From the institution",
            patient_didnt_show_up: "Patient didn't show up",
            technical_issue: "Technical issue",
            payment_by_ep_card: "Payment by EP card",
            cancel: "Cancel",
            select_cancel_reason: "Choose a cancellation reason!",
            confirm_cancel: "Are you sure to cancel?",
            selected_reservation_deleted:
                "The selected reservation will be cancelled!",
            reservations: "Reservations",
            no_access:
                "This reservation was made at an institution to which you do not have access",
            start_end_time_error:
                "The minute value of the given time must be divisible by 5.",
            selected_examinations: "{{count}} selected examination(s)",
            attention: "Attention!",
            doctor_reservation_modify:
                "Modify appointments for <span>{{doctor}}</span>",
            modify_text:
                "The modification affects the following specific appointment days. Please select the one you would like to overwrite.",
            date: "Date",
            week_upper: "Week",
            day: "Day",
            calendar_open_close: "Calendar Open - Close",
            room: "Room",
        },
    },
    hu: {
        translation: {
            calendar_settings: "Naptár beállítása",
            edit_profile: "Adatlap szerkesztése",
            change_consultation: "Naptár beállítása",
            add_consultation: "Rendelés hozzáadása",
            weekly_view: "Általános heti nézet",
            daily_view: "Napi nézet",
            unsaved_data_loss: "Minden nem mentett adat el fog veszni!",
            Monday: "Hétfő",
            Tuesday: "Kedd",
            Wednesday: "Szerda",
            Thursday: "Csütörtök",
            Friday: "Péntek",
            Saturday: "Szombat",
            Sunday: "Vasárnap",
            odd_week: "Páratlan hét",
            even_week: "Páros hét",
            consultation_time: "Rendelés idő",
            sure_close: "Biztosan bezárod",
            back: "Vissza",
            close: "Bezárás",
            all_examinations: "Minden vizsgálat",
            no_room_selected: "Nincs rendelő kiválasztva",
            use_odd_week: "Páratlan hét használata",
            save: "Mentés",
            week: "hét",
            patient: "Páciens",
            birth_date: "Születési dátum",
            qualification: "Szakterület",
            specialization: "Szolgáltatás",
            choose: "Válasszon...",
            from_patient: "A páciens részéről",
            from_institution: "Az intézmény részéről",
            patient_didnt_show_up: "A páciens nem jelent meg",
            technical_issue: "Technikai probléma",
            payment_by_ep_card: "Fizetés EP kártyával",
            cancel: "Lemondás",
            select_cancel_reason: "Válasszon lemondási indokot!",
            confirm_cancel: "Biztosan lemondja?",
            selected_reservation_deleted:
                "A kiválasztott foglalás törlésre kerül!",
            reservations: "Foglalások",
            no_access:
                "Ez a foglalás egy olyan intézményben történt, amihez Önnek nincs hozzáférése",
            start_end_time_error:
                "A megadott idő perceinek száma 5-el oszthatónak kell hogy legyen!",
            selected_examinations: "{{count}} kiválasztott vizsgálat",
            attention: "Figyelem!",
            doctor_reservation_modify:
                "<span>{{doctor}}</span> időpontjainak módosítása",
            modify_text:
                "A módosítás az alábbi egyedi rendelési napokat érinti. Kérjük, válassza ki, melyiket szeretné felülírni.",
            date: "Dátum",
            week_upper: "Hét",
            day: "Nap",
            calendar_open_close: "Naptár nyitás - zárás",
            room: "Rendelő",
        },
    },
    de: {
        translation: {
            calendar_settings: "Kalendereinstellungen",
            edit_profile: "Profil bearbeiten",
            change_consultation: "Beratung ändern",
            add_consultation: "Beratung hinzufügen",
            weekly_view: "Wochenansicht",
            daily_view: "Tagesansicht",
            unsaved_data_loss: "Alle ungespeicherten Daten gehen verloren!",
            Monday: "Montag",
            Tuesday: "Dienstag",
            Wednesday: "Mittwoch",
            Thursday: "Donnerstag",
            Friday: "Freitag",
            Saturday: "Samstag",
            Sunday: "Sonntag",
            odd_week: "Ungerade Woche",
            even_week: "Gerade Woche",
            consultation_time: "Beratungszeit",
            sure_close: "Sind Sie sicher, dass Sie schließen möchten?",
            back: "Zurück",
            close: "Schließen",
            all_examinations: "Alle Untersuchungen",
            no_room_selected: "Kein Raum ausgewählt",
            use_odd_week: "Ungerade Woche verwenden",
            save: "Speichern",
            week: "Woche",
            patient: "Patient",
            birth_date: "Geburtsdatum",
            qualification: "Qualifikation",
            specialization: "Spezialisierung",
            choose: "Wählen...",
            from_patient: "Vom Patienten",
            from_institution: "Von der Institution",
            patient_didnt_show_up: "Der Patient ist nicht erschienen",
            technical_issue: "Technisches Problem",
            payment_by_ep_card: "Zahlung mit EP-Karte",
            cancel: "Abbrechen",
            select_cancel_reason: "Wählen Sie einen Stornierungsgrund!",
            confirm_cancel: "Sind Sie sicher, dass Sie stornieren möchten?",
            selected_reservation_deleted:
                "Die ausgewählte Reservierung wird storniert!",
            reservations: "Reservierungen",
            no_access:
                "Diese Reservierung wurde in einer Institution vorgenommen, auf die Sie keinen Zugriff haben",
            start_end_time_error:
                "Der Minutenwert der angegebenen Zeit muss durch 5 teilbar sein.",
            selected_examinations: "{{count}} ausgewählte Untersuchung",
            attention: "Achtung!",
            doctor_reservation_modify:
                "Termine von <span>{{doctor}}</span> ändern",
            modify_text:
                "Die Änderung betrifft die folgenden einzelnen Behandlungstage. Bitte wählen Sie aus, welchen Sie überschreiben möchten.",
            date: "Datum",
            week_upper: "Woche",
            day: "Tag",
            calendar_open_close: "Kalender Öffnen - Schließen",
            room: "Zimmer",
        },
    },
    ro: {
        translation: {
            calendar_settings: "Setări calendar",
            edit_profile: "Editează profilul",
            change_consultation: "Schimbă consultația",
            add_consultation: "Adaugă consultație",
            weekly_view: "Vizualizare săptămânală",
            daily_view: "Vizualizare zilnică",
            unsaved_data_loss: "Toate datele nesalvate vor fi pierdute!",
            Monday: "Luni",
            Tuesday: "Marți",
            Wednesday: "Miercuri",
            Thursday: "Joi",
            Friday: "Vineri",
            Saturday: "Sâmbătă",
            Sunday: "Duminică",
            odd_week: "Săptămână impară",
            even_week: "Săptămână pară",
            consultation_time: "Ora consultației",
            sure_close: "Sunteți sigur că doriți să închideți?",
            back: "Înapoi",
            close: "Închide",
            all_examinations: "Toate examinările",
            no_room_selected: "Nu a fost selectată nicio cameră",
            use_odd_week: "Folosește săptămână impară",
            save: "Salvează",
            week: "săptămână",
            patient: "Pacient",
            birth_date: "Data nașterii",
            qualification: "Calificare",
            specialization: "Specializare",
            choose: "Alegeți...",
            from_patient: "De la pacient",
            from_institution: "De la instituție",
            patient_didnt_show_up: "Pacientul nu s-a prezentat",
            technical_issue: "Problemă tehnică",
            payment_by_ep_card: "Plată cu cardul EP",
            cancel: "Anulează",
            select_cancel_reason: "Alegeți un motiv de anulare!",
            confirm_cancel: "Sunteți sigur că doriți să anulați?",
            selected_reservation_deleted: "Rezervarea selectată va fi anulată!",
            reservations: "Rezervări",
            no_access:
                "Această rezervare a fost făcută la o instituție la care nu aveți acces",
            start_end_time_error:
                "Valoarea minutelor pentru ora specificată trebuie să fie divizibilă cu 5.",
            selected_examinations: "{{count}} examinări selectate",
            attention: "Atenție!",
            doctor_reservation_modify:
                "Modifică programările pentru <span>{{doctor}}</span>",
            modify_text:
                "Modificarea afectează următoarele zile de consultație specifice. Vă rugăm să selectați pe cea pe care doriți să o suprascrieți.",
            date: "Dată",
            week_upper: "Săptămână",
            day: "Zi",
            calendar_open_close: "Deschidere - Închidere Calendar",
            room: "Cabinet",
        },
    },
    es: {
        translation: {
            calendar_settings: "Configuración del calendario",
            edit_profile: "Editar perfil",
            change_consultation: "Cambiar consulta",
            add_consultation: "Agregar consulta",
            weekly_view: "Vista semanal",
            daily_view: "Vista diaria",
            unsaved_data_loss: "¡Todos los datos no guardados se perderán!",
            Monday: "Lunes",
            Tuesday: "Martes",
            Wednesday: "Miércoles",
            Thursday: "Jueves",
            Friday: "Viernes",
            Saturday: "Sábado",
            Sunday: "Domingo",
            odd_week: "Semana impar",
            even_week: "Semana par",
            consultation_time: "Hora de la consulta",
            sure_close: "¿Está seguro de que desea cerrar?",
            back: "Atrás",
            close: "Cerrar",
            all_examinations: "Todos los exámenes",
            no_room_selected: "No se ha seleccionado sala",
            use_odd_week: "Usar semana impar",
            save: "Guardar",
            week: "semana",
            patient: "Paciente",
            birth_date: "Fecha de nacimiento",
            qualification: "Calificación",
            specialization: "Especialización",
            choose: "Elige...",
            from_patient: "Del paciente",
            from_institution: "De la institución",
            patient_didnt_show_up: "El paciente no se presentó",
            technical_issue: "Problema técnico",
            payment_by_ep_card: "Pago con tarjeta EP",
            cancel: "Cancelar",
            select_cancel_reason: "¡Seleccione un motivo de cancelación!",
            confirm_cancel: "¿Está seguro de que desea cancelar?",
            selected_reservation_deleted:
                "La reserva seleccionada será cancelada.",
            reservations: "Reservas",
            no_access:
                "Esta reserva se realizó en una institución a la que no tiene acceso",
            start_end_time_error:
                "El valor de los minutos de la hora indicada debe ser divisible por 5.",
            selected_examinations: "{{count}} exámenes seleccionados",
            attention: "¡Atención!",
            doctor_reservation_modify:
                "Modificar citas de <span>{{doctor}}</span>",
            modify_text:
                "La modificación afecta a los siguientes días de consulta específicos. Por favor, seleccione cuál desea sobrescribir.",
            date: "Fecha",
            week_upper: "Semana",
            day: "Día",
            calendar_open_close: "Apertura - Cierre del Calendario",
            room: "Consultorio",
        },
    },
};

// initialize i18n with the configuration
i18n.use(initReactI18next).init({
    resources,
    lng: window.localStorage.getItem("i18nextLng") || "en", // set the default language
    fallbackLng: "en", // fallback language if a translation is not available for the selected language
    interpolation: {
        escapeValue: false, // react already safe from xss
    },
});
